<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="tab.automationConfig" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(warehouse)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="pickupMode.name" title="business.label.pickupMode"/>
        <vxe-column field="region.name" title="business.label.unitedRegion"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoSeeding" title="business.label.autoSeeding" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoPacking" title="business.label.autoPacking" width="70"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <vxe-modal v-model="visible" :loading="loading" :title="$t('tab.automationConfig')" type="confirm" width="40%" @confirm="confirm">
      <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="config" :rules="rules" :wrapper-col="wrapperCol">
        <a-row style="margin-left: -4%;margin-right: 4%">
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.pickupMode')">
              <vxe-select v-model="config.pickupMode.id" :options="pickupModes" clearable style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.unitedRegion')">
              <vxe-select v-model="config.region.id" :options="regions" clearable style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('business.label.autoSeeding')">
              <vxe-switch v-model="config.autoSeeding"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('business.label.autoPacking')">
              <vxe-switch v-model="config.autoPacking"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-modal>
  </div>
</template>
<script>
import { deleteOne, findAll, findOne, save } from '@/api/Api'
import { Warehouse } from '@/api/dto/common/Warehouse'
import { AutomationConfig } from '@/api/dto/config/AutomationConfig'

export default {
  name: 'AutomationConfig',
  data() {
    return {
      loading: false,
      visible: false,
      warehouse: new Warehouse(),
      list: [],
      config: new AutomationConfig(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {}
    }
  },
  props: {
    pickupModes: {
      type: Array,
      default: []
    },
    regions: {
      type: Array,
      default: []
    }
  },
  methods: {
    refresh(warehouse) {
      this.warehouse = warehouse
      if (this.warehouse.isNew()) {
        return this.$message.warning('请先选择仓库')
      }
      this.loading = true
      findAll('automationConfigFactory', { 'warehouse.id': this.warehouse.id }).then(res => {
        if (res.success) {
          this.list = res.result.map(item => {
            return new AutomationConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.visible = true
      this.config = new AutomationConfig()
    },
    edit(row, copy) {
      this.visible = true
      this.loading = true
      findOne('automationConfigFactory', { id: row.id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.config = new AutomationConfig(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const config = this.config.toJSONObject()
      config.warehouse = this.warehouse
      save('automationConfigPersister', config).then(res => {
        if (res.success) {
          this.config = new AutomationConfig(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.refresh(this.warehouse)
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('automationConfigDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.refresh(this.warehouse)
            this.$message.success(this.$t('message.deleteSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.list.splice(this.list.indexOf(row), 1)
      }
    }
  }
}
</script>